// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"25a51d85","60":"ac035823","164":"92f8a314","203":"4b7048b6","205":"4206544c","946":"b42324b1","988":"5b172af9"}[chunkId] + ".chunk.js";
};